import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { CalendarDays, MapPin, Trophy, User, Users, Map } from "lucide-react";
// Zakładam, że te komponenty masz w innym pliku
import { UpcomingCalendar } from "./upcomingCalendar";
import MatchScore from "./resultbox2";

// --- STYLED COMPONENTS ---

const ProfileWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 100px auto;
  background: #ffffff;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.3s ease;
  overflow: hidden; 

  &:hover {
    box-shadow: 0 20px 50px rgba(0,0,0,0.05);
  }

  @media (max-width: 768px) {
    margin: 0 auto 50px auto;
    border-left: none;
    border-right: none;
  }
`;

const ProfileAccentBar = styled.div`
  width: 100%;
  height: 6px;
  background: linear-gradient(90deg, ${props => props.color1} 0%, ${props => props.color2} 100%);
`;

const ProfileHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 120px 5% 60px 5%;
  background-color: #111;
  color: #fff;
  flex-wrap: wrap;
  gap: 30px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* TUTAJ MAGIA: Używamy propsa 'bgImage' */
    background-image: url(${props => props.bgImage || './photos/photo3.jpg'}); 
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.3) 100%);
    z-index: 2;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 80px 5% 40px 5%;
  }

  @media (max-width: 480px) {
    padding: 60px 5% 30px 5%;
  }
`;

const HeaderContent = styled.div`
  position: relative;
  z-index: 3;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`;

const YearDisplay = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: clamp(0.8rem, 2vw, 1rem);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 4px;
    color: #ccc;
    margin-bottom: 5px;
  }

  h2 {
    font-size: clamp(3.5rem, 10vw, 7rem);
    font-weight: 900;
    line-height: 0.85;
    margin: 0;
    color: #fff;
    letter-spacing: -3px;
  }
`;

const CoachInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 768px) {
    align-items: flex-start;
  }

  span {
    font-size: 0.85rem;
    text-transform: uppercase;
    color: #bbb;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 4px;
  }

  strong {
    font-size: clamp(1.2rem, 4vw, 1.6rem);
    font-weight: 800;
    color: #fff;
    text-transform: uppercase;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  border-bottom: 1px solid #eee;
  background: #fff;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StatBox = styled.div`
  padding: 30px 5%;
  display: flex;
  align-items: center;
  gap: 20px;
  border-right: 1px solid #eee;

  &:last-child {
    border-right: none;
  }

  @media (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid #eee;
    padding: 20px 5%;
    
    &:last-child {
      border-bottom: none;
    }
  }

  svg {
    color: #ccc;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }
`;

const StatText = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: 0.75rem;
    text-transform: uppercase;
    color: #999;
    font-weight: 700;
    letter-spacing: 1px;
    margin-bottom: 4px;
  }

  strong {
    font-size: clamp(1rem, 3vw, 1.1rem);
    font-weight: 800;
    color: #111;
  }
`;

// --- POPRAWIONE MENU ---
const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #eee;
  background: #fff;
  
  /* Na małych ekranach menu układa się pionowo lub ściśle dzieli miejsce */
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const TabButton = styled.button`
  flex: 1;
  background: ${props => props.active ? "#f9f9f9" : "transparent"};
  border: none;
  padding: 25px 10px;
  font-size: 0.95rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${props => props.active ? "#111" : "#999"};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  position: relative;
  transition: all 0.3s ease;

  svg {
    width: 18px;
    height: 18px;
    transition: transform 0.3s ease;
    transform: ${props => props.active ? "scale(1.1)" : "scale(1)"};
    flex-shrink: 0;
  }

  &:hover {
    color: #111;
    background: #f9f9f9;
  }

  /* Podkreślenie na desktop/tablet */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #111;
    transform: ${props => props.active ? "scaleX(1)" : "scaleX(0)"};
    transition: transform 0.3s ease;
  }

  /* Specyficzne style dla mobile (pionowy układ) */
  @media (max-width: 480px) {
    padding: 20px 15px;
    justify-content: flex-start; /* Do lewej krawędzi zamiast środka */
    font-size: 0.85rem;
    border-bottom: 1px solid #eee;

    /* Podkreślenie zmienia się w lewy pasek akcentujący na mobile */
    &::after {
      width: 4px;
      height: 100%;
      top: 0;
      bottom: auto;
      transform: ${props => props.active ? "scaleY(1)" : "scaleY(0)"};
    }

    &:last-child {
      border-bottom: none;
    }
  }
`;

const TabContentWrapper = styled.div`
  padding: 20px 5% 60px 5%;
  background: #fff;
  min-height: 300px;

  @media (max-width: 768px) {
    padding: 15px 5% 40px 5%;
  }
`;

const SectionTitle = styled.h3`
  font-size: clamp(1.5rem, 5vw, 2rem);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: -1px;
  margin: 20px 0 30px 0;
  color: #111;
`;

const LocationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr; /* Na najmniejszych wymuszamy 1 kolumnę by uniknąć overflow */
    gap: 20px;
  }
`;

const LocationCard = styled.div`
  border: 1px solid #eee;
  padding: 30px;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  gap: 15px;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    padding: 20px;
  }

  &:hover {
    background: #111;
    border-color: #111;
    transform: translateY(-5px);
    
    h4, p, svg {
      color: #fff;
    }
  }

  svg {
    color: #888;
    width: 32px;
    height: 32px;
    transition: color 0.3s ease;
  }

  h4 {
    font-size: clamp(1.1rem, 3vw, 1.2rem);
    font-weight: 800;
    text-transform: uppercase;
    margin: 0;
    color: #111;
    transition: color 0.3s ease;
  }

  p {
    font-size: 0.95rem;
    color: #666;
    margin: 0;
    transition: color 0.3s ease;
  }
`;

// --- KOMPONENT GŁÓWNY ---

export const ProfilRocznika = ({
  rocznik,
  trener,
  liczbaZawodników,
  miejsceTreningów,
  miejscaTreningow = [],
  dniTreningow = [],
  kolorTla1 = "#111",
  kolorTla2 = "#888",
  wyniki = [],
  rocznikId,
  zdjecieDruzyny = ''
}) => {
  const [chosen, setChosen] = useState(0);
  const [events, setEvents] = useState([]);

  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}.${String(today.getMonth() + 1).padStart(2, "0")}.${today.getFullYear()}`;

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`https://api.pth-hokej.pl/api/eventsRocznik?rocznik=${rocznik}`);
        if (!response.ok) throw new Error("Błąd przy pobieraniu wydarzeń");
        const data = await response.json();
        setEvents(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchEvents();
  }, [rocznik]);

  return (
    <ProfileWrapper>
      <ProfileAccentBar color1={kolorTla1} color2={kolorTla2} />

      <ProfileHeader bgImage={zdjecieDruzyny}>
        <HeaderContent>
          <YearDisplay>
            <span>Drużyna</span>
            <h2>{rocznik}</h2>
          </YearDisplay>

          <CoachInfo>
            <span>Trener Zespołu</span>
            <strong>{trener}</strong>
          </CoachInfo>
        </HeaderContent>
      </ProfileHeader>

      <StatsGrid>
        <StatBox>
          <User />
          <StatText>
            <span>Prowadzący</span>
            <strong>{trener}</strong>
          </StatText>
        </StatBox>
        <StatBox>
          <Users />
          <StatText>
            <span>Kadra</span>
            <strong>{liczbaZawodników} zawodników</strong>
          </StatText>
        </StatBox>
        <StatBox>
          <MapPin />
          <StatText>
            <span>Główna Baza</span>
            <strong>{miejsceTreningów}</strong>
          </StatText>
        </StatBox>
      </StatsGrid>

      {/* POPRAWIONE MENU TABS */}
      <TabsContainer>
        <TabButton active={chosen === 0} onClick={() => setChosen(0)}>
          <CalendarDays /> Nadchodzące
        </TabButton>
        <TabButton active={chosen === 1} onClick={() => setChosen(1)}>
          <Map /> Obiekty
        </TabButton>
        <TabButton active={chosen === 2} onClick={() => setChosen(2)}>
          <Trophy /> Wyniki
        </TabButton>
      </TabsContainer>

      <TabContentWrapper>
        {/* ZAKŁADKA 0: KALENDARZ */}
        {chosen === 0 && (
          <div>
            <SectionTitle>Terminarz</SectionTitle>
            <UpcomingCalendar
              startDate={formattedDate}
              eventsDefinitions={dniTreningow}
              rocznikId={rocznikId}
            />
          </div>
        )}

        {/* ZAKŁADKA 1: MIEJSCA TRENINGÓW */}
        {chosen === 1 && (
          <div>
            <SectionTitle>Baza Sportowa</SectionTitle>
            {miejscaTreningow.length > 0 ? (
              <LocationsGrid>
                {miejscaTreningow.map(({ nazwa, adres }, idx) => (
                  <LocationCard key={idx}>
                    <MapPin />
                    <div>
                      <h4>{nazwa}</h4>
                      <p>{adres}</p>
                    </div>
                  </LocationCard>
                ))}
              </LocationsGrid>
            ) : (
              <p style={{ color: "#999", fontSize: "1.1rem" }}>
                Brak przypisanych obiektów dla tego rocznika.
              </p>
            )}
          </div>
        )}

        {/* ZAKŁADKA 2: WYNIKI */}
        {chosen === 2 && (
          <div>
            <SectionTitle>Ostatnie Wyniki</SectionTitle>
            {wyniki.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {wyniki.map((wynik) => (
                  <MatchScore
                    team1Name={"Wilki " + rocznik}
                    team1Color="#111"
                    team1Points={wynik?.punktyN}
                    team1Logo={"./logo_PTH.png"}
                    team2Name={wynik?.rywal}
                    team2Color={wynik?.kolorRywal || "#888"}
                    team2Points={wynik?.punktyR}
                    team2Logo={wynik?.logoRywal}
                    key={wynik._id}
                  />
                ))}
              </div>
            ) : (
              <p style={{ color: "#999", fontSize: "1.1rem" }}>
                Brak zapisanych wyników dla tego rocznika.
              </p>
            )}
          </div>
        )}
      </TabContentWrapper>
    </ProfileWrapper>
  );
};